<app-loading-overlay [isLoading]="isLoading"></app-loading-overlay>
<div class="history-content">
  <div class="history-toolbar">
    <nz-radio-group [(ngModel)]="selectedCategory" (ngModelChange)="onCategoryChange($event)" class="category-switch">
      <label nz-radio-button [nzValue]="HistoryCategory.Workbench">
        Workbench
        <nz-badge [nzCount]="workbenchCount" [nzShowZero]="true"></nz-badge>
      </label>
      <label nz-radio-button [nzValue]="HistoryCategory.Scheduler">
        Scheduler
        <nz-badge [nzCount]="schedulerCount" [nzShowZero]="true"></nz-badge>
      </label>
      <label *ngIf="!isMarketingUser" nz-radio-button [nzValue]="HistoryCategory.FanSegment">
        Fan Segment
        <nz-badge [nzCount]="fanSegmentCount" [nzShowZero]="true"></nz-badge>
      </label>
    </nz-radio-group>

    <nz-input-group class="history-search" [nzSuffix]="searchActions">
      <input nz-input [(ngModel)]="searchTerm" [placeholder]="searchPlaceholder" />
    </nz-input-group>

    <ng-template #searchActions>
      <div class="search-actions">
        <button
          *ngIf="searchTerm"
          type="button"
          class="clear-search-btn"
          (click)="clearSearch()"
          aria-label="Clear search"
        >
          <span nz-icon nzType="close"></span>
        </button>
        <span nz-icon nzType="search"></span>
      </div>
    </ng-template>
  </div>

  <ng-template #deleteHistoryConfirmContent>
    <p>This action will permanently delete the selected query run history. This cannot be undone.</p>
    <div class="delete-history-confirm-alert">
      <span nz-icon nzType="delete" nzTheme="outline"></span>
      <span>All logs, results, and related data will be permanently removed.</span>
    </div>
  </ng-template>

  <app-workbench-history
    *ngIf="selectedCategory === HistoryCategory.Workbench"
    [searchTerm]="searchTerm"
    [rows]="workbenchRows"
    (deleteEvent)="deleteHistory($event)"
  ></app-workbench-history>
  <app-scheduler-history
    *ngIf="selectedCategory === HistoryCategory.Scheduler"
    [searchTerm]="searchTerm"
    (deleteEvent)="deleteHistory($event)"
    [rows]="schedulerRows"
  ></app-scheduler-history>
  <app-segment-history
    *ngIf="!isMarketingUser && selectedCategory === HistoryCategory.FanSegment"
    [searchTerm]="searchTerm"
    (deleteEvent)="deleteHistory($event)"
    [rows]="segmentRows"
  ></app-segment-history>
</div>
